import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useDataLayer from '../../../../shared/hooks/global/UseDataLayer';
import { useAccount } from '../../../../shared/contexts/account/AccountContexts';
import { ProjectData } from '../models/ProjectData';
import { createProject } from '../../../../shared/services/projects/ProjectService';
import { FIRST_CHATBEAT_PROJECT_KEY } from '../../preview/helpers/ProjectPreviewHelper';
import { PROJECTS } from '../../../../shared/routes/path';

export const useProjectSubmit = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { accountResponse, refetchData } = useAccount();
  const { pushDataLayer } = useDataLayer();

  const submitProject = async (projectData: ProjectData) => {
    const projectsResponseData = await createProject(projectData);

    if (!projectsResponseData?.projectsResponse?.length) {
      throw new Error(t('projectCreationFailed'));
    }

    const newProjectId = projectsResponseData.newProjectId;

    if (accountResponse) {
      pushDataLayer({
        event: 'add_project',
        project_id: newProjectId,
        email_hashed: accountResponse.email,
        user_id: accountResponse.userId.toString(),
        account_id: accountResponse.accountId.toString(),
      });
    }

    if (accountResponse?.allMonitorsCount === 0) {
      localStorage.setItem(FIRST_CHATBEAT_PROJECT_KEY, 'pending_first_view');
    }

    refetchData();
    navigate(`${PROJECTS}/${newProjectId}`);
  };

  return { submitProject };
};
